import { IRating } from '@/common/domain/Rating.domain';
import { ProductOption } from '@/entities/Viator/domain/Viator.domain';

export const formatList = (items: string[]): string => {
    if (!items?.length) return '';
    const listItems = items.map((i) => `<li>${i}</li>`);
    return `<ul>${listItems.join('')}</ul>`;
};

export const formatProductOptions = (options: { title: string; description: string }[]): string => {
    if (!options.length) return '';
    const optionHtml = options
        .map(
            (opt) =>
                `<div class="product-option"><strong>${opt.title}</strong><p>${opt.description}</p></div>`
        )
        .join('');
    return `<div class="product-options">${optionHtml}</div>`;
};

export const formatDuration = (options: ProductOption[]): string => {
    const minDuration = options.reduce((res, i) => {
        if (res === 0 && i.duration_sec > 0) {
            return i.duration_sec;
        }

        if (res > i.duration_sec) {
            return i.duration_sec;
        }

        return res;
    }, 0);

    const minutes = minDuration / 60;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours && mins) return `${hours}h ${mins}m`;
    if (hours) return `${hours}h`;
    if (mins) return `${mins}m`;
    return '';
};

export const getMinPrice = (options: ProductOption[]): { price: number; currency: string } => {
    const minPriceOption = options
        .flatMap((item) => item.price_options ?? [])
        .reduce<(typeof options)[number]['price_options'][number] | undefined>((min, option) => {
            if (!min || option.price < min.price) return option;
            return min;
        }, undefined);

    return minPriceOption
        ? { price: minPriceOption.price, currency: minPriceOption.currency }
        : { price: 0, currency: '' };
};

export const convertRatingToStars = (rating: number): IRating => {
    const full = Math.floor(rating);
    const half = rating % 1 >= 0.5 ? 1 : 0;
    return { full, half };
};
